import { HISTORY_CATEGORIES, HISTORY_TYPE_PARAM } from './historyCategories';

export const HEALTH_RECORDS_PERMISSIONS = ['patients_medical_history.read', 'vitals.read'];

export const HEALTH_RECORDS_TABS = [
  {
    label: 'Histories',
    path: 'histories',
    permission: 'patients_medical_history.read',
    param: HISTORY_TYPE_PARAM,
    children: HISTORY_CATEGORIES
  },
  { label: 'Medications', path: 'medications', permission: 'patients_medical_history.read' },
  { label: 'Allergies', path: 'allergies', permission: 'patients_medical_history.read' },
  { label: 'Immunizations', path: 'vaccines', permission: 'patients_medical_history.read' },
  { label: 'Vitals', path: 'vitals', permission: 'vitals.read' }
];

export default HEALTH_RECORDS_TABS;
